/**
 * https://www.pdftron.com/api/web/Core.DocumentViewer.html#getDocument__anchor
 */
export default () => window.documentViewer.getDocument();
